import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("en_admin_token");
export const setToken = (t) => localStorage.setItem("en_admin_token", t);
export const clearToken = () => localStorage.removeItem("en_admin_token");

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const fetchPublicConfig = async () => {
  const { data } = await axios.get(`${API}/public/config`);
  return data;
};

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const imageUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;
